var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStyleToggleIconDouble = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59267 3.16681H2.57416C1.25008 3.16681 0.166748 4.25014 0.166748 5.57421V22.4261C0.166748 23.7501 1.25008 24.8335 2.57416 24.8335H8.59267V26.0372C8.59267 26.6992 9.13434 27.2409 9.79638 27.2409C10.4584 27.2409 11.0001 26.6992 11.0001 26.0372V1.9631C11.0001 1.30107 10.4584 0.759399 9.79638 0.759399C9.13434 0.759399 8.59267 1.30107 8.59267 1.9631V3.16681ZM8.59267 21.2224H2.57416L8.59267 14.0001V21.2224ZM19.426 3.16681H13.4075V5.57421H18.2223C18.8843 5.57421 19.426 6.11588 19.426 6.77792V21.2224L13.4075 14.0001V24.8335H19.426C20.7501 24.8335 21.8334 23.7501 21.8334 22.4261V5.57421C21.8334 4.25014 20.7501 3.16681 19.426 3.16681Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStyleToggleIconDouble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/styleToggle_icon_double.c6d09517.svg";
export { ForwardRef as ReactComponent };